export class FilterChangeEvent {    

    constructor( public field: string, public values: string[] ) {

    }
}